import angular from 'angular';

import {SegmentsController} from './segments.controller.js';
import {SegmentEditionController} from './segment-edition.controller.js';
import {segmentCondition} from './segment-condition.directive';
import {SegmentsService} from './segments.service.js';


angular
  .module('segments', [])
  .controller('SegmentsController', SegmentsController)
  .controller('SegmentEditionController', SegmentEditionController)
  .directive('segmentCondition', segmentCondition)
  .factory('SegmentsFactory', SegmentsService.SegmentsFactory);
